var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDislike = function SvgDislike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M10.407 3.667v6.773c0 .267-.08.527-.226.747l-1.82 2.707c-.287.433-1 .74-1.607.513-.653-.22-1.087-.953-.947-1.607l.347-2.18a.67.67 0 0 0-.14-.52.62.62 0 0 0-.46-.206h-2.74c-.527 0-.98-.214-1.247-.587-.253-.36-.3-.827-.133-1.3l1.64-4.993c.207-.827 1.107-1.5 2-1.5h2.6c.447 0 1.073.153 1.36.44l.853.66c.327.253.52.64.52 1.053M12.528 11.74h.686c1.034 0 1.454-.4 1.454-1.387v-6.7c0-.986-.42-1.386-1.454-1.386h-.686c-1.034 0-1.454.4-1.454 1.386v6.707c0 .98.42 1.38 1.454 1.38"
  })));
};
export { SvgDislike as ReactComponent };